export default __webpack_public_path__ + "static/media/copyUser.284535ee.svg";